import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import Utils from '@shared/utils/utils';
import { FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Company } from '@shared/enums/company';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';


@Component({
  selector: 'app-place-edit',
  templateUrl: './place-edit.component.html',
  styleUrls: ['./place-edit.component.scss']
})
export class PlaceEditComponent extends DialogBase implements OnInit {
  title: any;
  saveButtonLabel: any;
  id: any;
  purchasePlaceInfo: any;

  companies: Company[];
  company: string;
  detailForm: FormGroup;
  display: boolean;

  error: any;
  pipe = new DatePipe('en-US');

  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    this.company = this.authService.getCurrentCompany();
    this.setFormControls();

    if (this.purchasePlaceInfo) {
      this.setEdit(this.purchasePlaceInfo);
    }
  }


  setFormControls() {
    let defaultControls: any = {
      name: [null, Validators.required],
      code: [null, Validators.compose([Validators.required, Validators.max(999), Validators.min(0)])],
      displayOrder: [null, Validators.compose([Validators.required, Validators.max(99), Validators.min(0)])],
      display: [null],
    }

    const idControl = {
      _id: [null],
    }

    if (this.purchasePlaceInfo) {
      defaultControls = {
        ...defaultControls,
        ...idControl,
      }
    }
    this.detailForm = this.fb.group(defaultControls);
  }

  setDisplayOptions(event?, isChecked?) {
    if (event) {
      this.display = event.target.checked;
    } else {
      this.display = isChecked || false;
    }
  }


  submitForm($event) {
    $event.stopPropagation();
    $event.preventDefault();

    const currentCompany = this.authService.getCurrentCompany();

    let purchasePlace = this.detailForm.getRawValue();
    if (this.display === undefined) {
      this.display = true;
    }
    purchasePlace.display = this.display;
    purchasePlace.company = currentCompany;
    purchasePlace.code = purchasePlace.code ? purchasePlace.code.padStart(2, '0') : '00';


    if (this.detailForm.invalid) {
      this.detailForm.markAllAsTouched();
      return;
    }

    this.spinnerService.start();
    this.apiService.purchasePlace.savePurchasePlace(purchasePlace)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        const messages = !this.purchasePlaceInfo ?
          { title: 'Purchase Place Create', text: 'Purchase Place created successfully' } :
          { title: 'Purchase Place Update', text: 'Purchase Place updated successfully' };
        Swal.fire({
          title: messages.title,
          text: messages.text,
          icon: 'success',
          allowOutsideClick: false,
        }).then((result) => {
          this.onClose.next(res);
          this.bsModalRef.hide();
        });
      }, err => Utils.showError(err));
  }

  private setEdit(purchaseInfo) {
    const form = this.detailForm.controls;
    console.log(purchaseInfo);
    Object.keys(form).forEach(key => {
      form[key].setValue(purchaseInfo[key]);
      if (key === 'code') {
        form[key].disable();
      }
    });
  }
}
